﻿declare const window: {
	__ENV: Environment
} & Window;

export type Environment = {
	REACT_APP_API_HOST: string
	REACT_APP_GOOGLE_API_KEY: string
	REACT_APP_HOSTNAME: string
}

const REACT_APP_API_HOST: string = window.__ENV.REACT_APP_API_HOST || "";
const REACT_APP_GOOGLE_API_KEY: string = window.__ENV.REACT_APP_GOOGLE_API_KEY || "";
const REACT_APP_HOSTNAME: string = window.__ENV.REACT_APP_HOSTNAME || window.location.hostname;

export {
	REACT_APP_API_HOST,
	REACT_APP_GOOGLE_API_KEY,
	REACT_APP_HOSTNAME
};
